import React, { useState, useEffect } from 'react';
import 'lightbox.js-react/dist/index.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import Layout from './assets/images/layout.png';
import { SlideshowLightbox } from 'lightbox.js-react';
import 'react-toastify/dist/ReactToastify.css';
import AllStalls from './constant.json';
import APICall from './Api';

function StallStatus() {
  const [loading, setLoading] = useState(false);
  const [openLayout, setOpenLayout] = useState(false);
  const [availableStalls, setAvailableStalls] = useState([]);

  useEffect(() => {
    fetchStallStatus();
  }, []);

  const fetchStallStatus = () => {
    setLoading(true);
    setAvailableStalls([]);
    APICall.getStallStatus().then((response) => {
      setLoading(false);
      if (response.success) {
        setAvailableStalls(response.data);
      } else {
        setAvailableStalls(
          AllStalls.map((stall) => {
            return {
              stall: stall.label,
              active: null,
            };
          })
        );
      }
    });
  };

  return (
    <div className='row w-100 p-4'>
      <div className='row'>
        {/* <div className='col-12 col-lg-4'>
          <div className='row'>
            <SlideshowLightbox
              className='container grid grid-cols-3 gap-2 mx-auto'
              open={openLayout}
              onOpen={() => {
                setOpenLayout(true);
              }}
              onClose={() => {
                setOpenLayout(false);
              }}
            >
              <img className='w-full rounded' src={Layout} style={{ width: '100%' }} />
            </SlideshowLightbox>
          </div>
        </div> */}
        <div className='col-12 col-lg-12'>
          {/* <div className='mb-3'>
            <input className='form-control' type='search' placeholder='Search Stall' />
          </div> */}
          <div className='flex flex-wrap row'>
            {availableStalls.map((stall) => {
              return (
                <div className='col-lg-2 col-xs-4 mb-3'>
                  <div className='card'>
                    <div className='card-header d-flex align-items-center justify-content-between'>
                      <span>{stall.stall}</span>{' '}
                      {stall.active ? (
                        <span className='badge bg-success'>Available</span>
                      ) : stall.active === null ? (
                        <span className='badge bg-danger'>--NA--</span>
                      ) : (
                        <span className='badge bg-primary'>Booked</span>
                      )}
                    </div>
                    {/* <div className='card-body p-1'>
                      <button className='btn btn-primary btn-sm'>Book Now</button>
                    </div> */}
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </div>
  );
}

export default StallStatus;
